'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// import '../assets/sass/main.scss';

// Main Components


// Import css


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _RequestMiddleware = require('./middlewares/RequestMiddleware');

var _RequestMiddleware2 = _interopRequireDefault(_RequestMiddleware);

var _lodash = require('lodash');

var _reduxRegexpRouter = require('redux-regexp-router');

var _App = require('./containers/App');

var _App2 = _interopRequireDefault(_App);

var _Module = require('./components/Module');

var _Module2 = _interopRequireDefault(_Module);

var _Login = require('./containers/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Logout = require('./containers/Logout');

var _Logout2 = _interopRequireDefault(_Logout);

var _NoMatch = require('./containers/NoMatch');

var _NoMatch2 = _interopRequireDefault(_NoMatch);

var _ProfileSettings = require('./containers/ProfileSettings');

var _ProfileSettings2 = _interopRequireDefault(_ProfileSettings);

var _reducers = require('./reducers');

var reducers = _interopRequireWildcard(_reducers);

var _BasicDependencies = require('./BasicDependencies');

var __ = _interopRequireWildcard(_BasicDependencies);

var _constants = require('./constants');

var _reduxDevtoolsExtension = require('redux-devtools-extension');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactAdmin = function () {
    function ReactAdmin(config) {
        var _this = this;

        _classCallCheck(this, ReactAdmin);

        this.defaultConfig = {
            defaultPath: _constants.DEFAULT_PATH,
            historyType: 'hash'
        };

        this.extractModules = function (modules, path, breadcrumbs) {
            path = path || '';
            breadcrumbs = breadcrumbs || [];
            modules.forEach(function (module) {
                var modulePath = module.path ? path + module.path : '';
                if (module.component || module.getComponent) _this.config.modulesByPath[modulePath] = module;

                module.absolutePath = (modulePath ? modulePath + '$' : '') || _constants.NOT_FOUND_PATH;
                module.url = module.absolutePath.replace('$', '').replace('^', '');
                module.breadcrumbs = [].concat(breadcrumbs, [module]);

                if (module.subModules) {
                    _this.extractModules(module.subModules, modulePath, module.breadcrumbs);
                }
            });
        };

        this.config = Object.assign({}, this.defaultConfig);

        Object.assign(this.config, config);

        if ((0, _lodash.get)(this.config, 'auth.isJWT')) {
            this.config.auth.jwtKey = btoa(this.config.auth.OAUTHClientId + ':' + this.config.auth.OAUTHSecret);
        }

        this.addDefaultModules(this.config.modules);

        // Generate modules by path
        this.config.modulesByPath = {};
        this.extractModules(this.config.modules);

        this.init();
    }

    _createClass(ReactAdmin, [{
        key: 'addDefaultModules',
        value: function addDefaultModules(modules) {
            // Модули работы с профилем/юзером
            if (this.config.auth && !this.config.auth.isImplicit) {
                modules.unshift({
                    title: 'Профиль',
                    icon: 'user',
                    subModules: [{
                        path: '/profile/',
                        title: 'Настройки',
                        component: _react2.default.createElement(_ProfileSettings2.default, null)
                    }, {
                        path: '/logout/',
                        title: 'Выйти',
                        component: _react2.default.createElement(_Logout2.default, null)
                    }]
                });

                modules.push({
                    path: '/login/',
                    title: 'Войти',
                    hidden: true,
                    component: _react2.default.createElement(_Login2.default, null)
                });
            }

            // NoMatch
            modules.push({
                path: _constants.NOT_FOUND_PATH,
                hidden: true,
                title: 'Страница не найдена',
                component: _react2.default.createElement(_NoMatch2.default, null)
            });
        }
    }, {
        key: 'init',
        value: function init() {
            // Create Store
            var store = (0, _reduxDevtoolsExtension.composeWithDevTools)((0, _redux.applyMiddleware)(_RequestMiddleware2.default, _reduxThunk2.default))(_redux.createStore)((0, _redux.combineReducers)(_extends({}, reducers, this.config.appReducers, _reduxRegexpRouter.routeReducers)), { config: this.config });

            var routes = Object.values(this.config.modulesByPath).map(function (item) {
                return _react2.default.createElement(
                    _reduxRegexpRouter.Route,
                    { key: item.path, path: item.path, item: item },
                    _react2.default.createElement(_Module2.default, { item: item })
                );
            });

            var History = (0, _reduxRegexpRouter.createHistory)(this.config.historyType);

            _reactDom2.default.render(_react2.default.createElement(
                _reactRedux.Provider,
                { store: store },
                _react2.default.createElement(
                    History,
                    null,
                    _react2.default.createElement(
                        _App2.default,
                        { store: store },
                        _react2.default.createElement(_reduxRegexpRouter.Switch, { children: routes })
                    )
                )
            ), document.getElementById(this.config.appId));
        }
    }]);

    return ReactAdmin;
}();

exports.default = ReactAdmin;
//# sourceMappingURL=AdminApp.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/AdminApp.js
// module id = 1272
// module chunks = 5